var base = global_config.BASE_URL;

//接口
var api = {
    sider: '/menus.json',
    // login:'/hxpay/online/login'
    getIpFromRequest: '/ttoa-ms/user/getIpFromRequest',
    login: '/hxpay/online/login',
    // login:'/wh_spdbpay_behind/online/login',
    addLocation: '/ttoa-ms/attendance/addLocation',
    getList: '/ttoa-ms/attendance/getList', 
    editLocation: '/ttoa-ms/attendance/editLocation',
    getLocation: '/ttoa-ms/attendance/getLocation',
    editLocation: '/ttoa-ms/attendance/editLocation',
    menuView: '/ttoa-ms/user/menuView',
    addMenu: '/ttoa-ms/menu/addMenu',
    deleteMenu: '/ttoa-ms/menu/deleteMenu',
    updateMenu: '/ttoa-ms/menu/updateMenu',
    removeLocation: '/ttoa-ms/attendance/removeLocation',
    getmember: '/ttoa-ms/user/userView',
    getMarkList: '/ttoa-ms/mark/getMarkListInfo',
    userViewList: '/ttoa-ms/user/userViewList',
    updateNotice: '/ttoa-ms/notice/updateNotice',//修改公告
    sendNotice: '/ttoa-ms/notice/sendNotice',//添加公告
    deleteNotice: '/ttoa-ms/notice/deleteNotice',//删除公告
    deleteNoticeList: '/ttoa-ms/notice/deleteNoticeList',//批量删除公告
    selectNotice: '/ttoa-ms/notice/selectNotice',//查询公告
    selectNoticeList: '/ttoa-ms/notice/selectNoticeList',//公告分页查询
    DepartmentView:'/ttoa-ms/dept/DepartmentView',//部门管理查询
    addDepartment:'/ttoa-ms/dept/addDepartment',//增加部门
    deleteDepartment:'/ttoa-ms/dept/deleteDepartment',//删除部门
    updateDepartment:'/ttoa-ms/dept/updateDepartment',//修改部门
    AAconfigMenuAuth:'/ttoa-ms/dept/configMenuAuth',//职位的菜单权限配置
    empView: '/ttoa-ms/emp/empView',//员工分页列表,
    empList:'/ttoa-ms/emp/empList',//员工分页列表,
    selectEmp: '/ttoa-ms/emp/selectEmp',//条件查询员工
    addEmp: '/ttoa-ms/emp/addEmp',//录入员工
    positionListView: 'ttoa-ms/dept/positionListView',//员工职位查询
    deleteEmp: '/ttoa-ms/emp/deleteEmp',//删除员工
    updateEmp: '/ttoa-ms/emp/updateEmp',//修改员工信息
    userView: '/ttoa-ms/user/userView',//用户分页列表
    userRoleView: '/ttoa-ms/user/roleView',//用户角色查询
    addUser: '/ttoa-ms/user/addUser',//添加用户
    deleteUser: '/ttoa-ms/user/deleteUser',//删除用户
    updateUser: '/ttoa-ms/user/updateUser',//修改用户信息
    roleView: '/ttoa-ms/role/roleView',//角色分页列表
    addRole: '/ttoa-ms/role/addRole',//添加角色
    deleteRole: '/ttoa-ms/role/deleteRole',//删除角色
    updateRole: '/ttoa-ms/role/updateRole',//修改角色信息
    menuView: '/ttoa-ms/user/menuView',//菜单权限列表
    configMenuAuth: '/ttoa-ms/role/configMenuAuth',//角色菜单权限配置
    getDeptName:'/ttoa-ms/dept/getDeptName',//部门查询
    selectaudittype:'/ttoa-ms/approves/selectaudittype',//查询审批类型列表
    addapprovers:'/ttoa-ms/approves/addapprovers',//添加审批规则
    selectauditrule:'/ttoa-ms/approves/selectauditrule',//查询审批规则列表
    deleteauditrule:'/ttoa-ms/approves/deleteauditrule',//删除审批规则
    selectauditruledetail:'/ttoa-ms/approves/selectauditruledetail',//查询审批规则详情
    updateauditrule:'/ttoa-ms/approves/updateauditrule',//修改审批规则
    querydict:'/ttoa-ms/dict/querydict',//查询数据字典
    adddict:'/ttoa-ms/dict/adddict',//新增数据字典
    deletedict:'/ttoa-ms/dict/deletedict',//删除数据字典
    updatedict:'/ttoa-ms/dict/updatedict',//修改数据字典
    querylogindict:'/ttoa-ms/dict/querylogindict',//登录查询数据字典
    reviewdict:'/ttoa-ms/dict/reviewdict',//数据最新化
    queryWeek:'/ttoa-ms/week/queryWeek',//周报查询
    reportWeek:'/ttoa-ms/week/reportWeek',//周报导出
    selectattenlist:'/ttoa-ms/atten/selectattenlist',//获取考勤信息
    getEmpMarkListInfo:'/ttoa-ms/mark/getEmpMarkListInfo',//获取打卡信息
    insertAttendance:'/ttoa-ms/workAttendance/insertAttendance',//手动导入考勤信息
    selectapprove:'/ttoa-ms/approves/selectapprove',//审批管理查询
    selectattachments:'/ttoa-ms/approves/selectattachments',//审批附件信息查询
    // attachement:'http://192.168.6.223:5081'+'/ttoa-mp',//附件
    getRegulaList:"/ttoa-ms/regula/getRegulaList",//查询规则列表（加班、补卡）
    insertRegula:"/ttoa-ms/regula/insertRegula",//加班规则添加
    deleteRegula:"/ttoa-ms/regula/deleteRegula",//规则删除（加班、补卡）
    updateRegula:"/ttoa-ms/regula/updateRegula",//加班规则修改
    selectHolidayList: '/ttoa-ms/holiday/selectHolidayList', // 假期类型列表查询
    deleteHoliday: '/ttoa-ms/holiday/deleteHoliday', // 删除假期类型
    insertHoliday: '/ttoa-ms/holiday/insertHoliday', // 新增假期类型
    updateHoliday: '/ttoa-ms/holiday/updateHoliday', // 修改假期类型
    selectHolidayUserList: '/ttoa-ms/holidayuser/selectHolidayUserList', // 假期余额查询
    deleteHolidayUserInfo: '/ttoa-ms/holidayuser/deleteHolidayUserInfo', // 删除假期余额
    updateHolidayUserInfo: '/ttoa-ms/holidayuser/updateHolidayUserInfo', // 修改假期余额
    insertHolidayUserInfo: '/ttoa-ms/holidayuser/insertHolidayUserInfo', // 导入假期余额
    setCheckAttDays: '/ttoa-ms/checkAtt/setCheckAttDays', // 新增补卡规则
    updateCheckAttDays: '/ttoa-ms/checkAtt/updateCheckAttDays', // 修改补卡规则
    reportattenlist: '/ttoa-ms/atten/reportattenlist', // 考勤记录导出
    selectnationallist: '/ttoa-ms/national/selectnationallist', //节假日查询
    updatenationallist: '/ttoa-ms/national/updatenationallist', //修改节假日
    deletenationallist: '/ttoa-ms/national/deletenationallist', //删除节假日
    addnationallist: '/ttoa-ms/national/addnationallist', //新增节假日
    selectHolidayBalance: '/ttoa-ms/holidayuser/selectHolidayBalance', // 查询假期变更记录
    downloadmubanfile: '/ttoa-ms/holidayuser/downloadmubanfile', // 下载假期余额模板
    updatePassword: '/ttoa-ms/user/updatePassword', // 修改密码
    feeApplication: '/ttoa-ms/finance/feeApplication/list', // 获取费用申请列表
    feeApplicationExport: '/ttoa-ms/finance/feeApplication/export/list', // 费用列表导出
    reimbursement: '/ttoa-ms/finance/reimbursement/list', // 获取报销申请列表
    reimbursementExport: '/ttoa-ms/finance/reimbursement/export/list', //报销列表导出
    paymentApplication: '/ttoa-ms/finance/paymentApplication/list', //付款申请记录列表
    paymentApplicationExport: '/ttoa-ms/finance/paymentApplication/export/list', // 付款申请记录导出
    businessTravel: '/ttoa-ms/checkWorkAttendance/businessTravel/list', //出差申请记录列表
    businessTravelExport: '/ttoa-ms/checkWorkAttendance/businessTravel/export/list', //出差申请记录导出
    workOvertime: '/ttoa-ms/checkWorkAttendance/workOvertime/list', //加班申请记录列表
    workOvertimeExport: '/ttoa-ms/checkWorkAttendance/workOvertime/export/list', //加班申请记录导出
    leaveList: '/ttoa-ms/checkWorkAttendance/leave/list', //请假申请记录列表
    leaveListExport: '/ttoa-ms/checkWorkAttendance/leave/export/list', //请假申请记录导出
    contractList: '/ttoa-ms/stamp/contract/list', //用章申请记录（合同类）列表
    contractListExport: '/ttoa-ms/stamp/contract/export/list', //用章申请记录（合同类）导出
    nonContractList: '/ttoa-ms/stamp/nonContract/list', //用章申请记录（非合同类）列表
    nonContractListExport: '/ttoa-ms/stamp/nonContract/export/list', //用章申请记录（非合同类）导出
    getGoOutList: '/ttoa-ms/goOut/getGoOutList', //外出申请记录列表
    getGoOutListExport: '/ttoa-ms/goOut/exportGoOut', //外出申请记录导出
    getClockList: '/ttoa-ms/clock/getClockList', //打卡补卡申请记录列表
    getClockListExport: '/ttoa-ms/clock/exportClock', //打卡补卡申请记录导出
    purchaseApplication: '/ttoa-ms/finance/purchaseApplication/list', //采购申请记录列表
    purchaseApplicationExport: '/ttoa-ms/finance/purchaseApplication/export/list', //采购申请列表导出
    getUserHolidayInfo: '/ttoa-ms/holidayuser/getUserHolidayInfo', //假期余额
    getUserInfoAndDeptInfo: '/ttoa-ms/holidayuser/getUserInfoAndDeptInfo', //获取用户以及所在部门可用于下拉
    getUserHolidayBalance: '/ttoa-ms/holidayuser/getUserHolidayBalance', //假期余额明细
    getHolidayType: '/ttoa-ms/holidayuser/getHolidayType', //获取假期类型
    getHolidayBalanceChangeRecord: '/ttoa-ms/holidayuser/getHolidayBalanceChangeRecord', // 假期余额变更记录
    importUserHolidayChange: '/ttoa-ms/holidayuser/importUserHolidayChange', //模板导入余额
    getHolidayUserInfoByEmpIdAndHolidayId: '/ttoa-ms/holidayuser/getHolidayUserInfoByEmpIdAndHolidayId', //获取截止日期和假期天数
    updateRgHolidayUserInfo: '/ttoa-ms/holidayuser/updateRgHolidayUserInfo', //手工调整假期
    exportUserHolidayInfo: '/ttoa-ms/holidayuser/exportUserHolidayInfo', //导出假期余额
    excleHolidayBalanceChangeRecord: '/ttoa-ms/holidayuser/excleHolidayBalanceChangeRecord', //导出手工调整列表
    feeTypeList: '/ttoa-ms/feeType/treeList', //费用类型列表
    feeTypeSave: '/ttoa-ms/feeType/save',//新增修改费用类型
    feeTypeDelete: '/ttoa-ms/feeType/delete', //删除费用类型
    feeApplyList: '/ttoa-ms/feeApply/list', //费用申请列表
    reimbursementList: '/ttoa-ms/reimbursement/list', // 报销申请列表
    feeReimbursementList: '/ttoa-ms/feeReimbursement/report/list', //费用报销统计表
    feeReimbursementDetail: '/ttoa-ms/feeReimbursement/report/detail', //费用报销明细
    feeReimbursementDetailExport: '/ttoa-ms/feeReimbursement/report/detail/export', //费用报销明细导出
    applyList: '/ttoa-ms/reimbursement/apply/list', //报销申请列表
    reimbursableList: '/ttoa-ms/feeApply/reimbursableList', //查询费用申请单
    feeApplyDetail: '/ttoa-ms/feeApply/detail', //获取费用申请详情
    getApproveAndCopyUser: '/ttoa-ms/approves/getApproveAndCopyUser', //获取审批流程
    reimbursementApply: '/ttoa-ms/reimbursement/apply', //提交报销申请
    approvedList: '/ttoa-ms/reimbursement/approved/list', //获取报销审批列表
    approveBusiness: '/ttoa-ms/approves/approveBusiness', //报销审批'同意拒绝'
    applyDetail: '/ttoa-ms/reimbursement/apply/detail', //报销审批详情
    feeList: '/ttoa-ms/feeType/list', //费用类型一级
    surplusAmount: '/ttoa-ms/feeApply/surplusAmount', //获取剩余借支金额
}

export default {
    base,
    api
};



// WEBPACK FOOTER //
// ./src/services/apis.js